import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ExternalLink, ArrowLeft } from "react-feather";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";

const GetSellerAccess = () => {
  const { id, name } = useParams();
  const navigate = useNavigate();

  const openGuestWindow = () => {
    // 1. Set the credentials in localStorage
    localStorage.setItem("seller_id", id);
    localStorage.setItem("user_role", "seller");
    localStorage.setItem("seller_first_name", name);

    // 2. Define window features to force a new window instead of a tab
    const width = 1200;
    const height = 800;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const windowFeatures = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`;

    // 3. Open the separate guest window
    window.open("/seller/dashboard", "SellerGuestWindow", windowFeatures);
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="card shadow-sm mt-4">
            <div className="card-body text-center py-5">
              <div className="mb-4">
                <div className="badge bg-soft-primary text-primary p-2 mb-3">
                  Seller Access Mode
                </div>
                <h3>Generate Seller Session</h3>
                <p className="text-muted">
                  You are about to access the dashboard for <strong>Seller: {name}</strong>.
                  <br />
                  This will open a dedicated window for the seller interface.
                </p>
              </div>

              <div className="d-flex justify-content-center gap-3">
                {/* Back Button */}
                <button 
                  className="btn btn-outline-secondary d-flex align-items-center" 
                  onClick={() => navigate(-1)}
                >
                  <ArrowLeft size={18} className="me-2" />
                  Go Back
                </button>

                {/* Trigger Window Button */}
                <button 
                  className="btn btn-danger d-flex align-items-center" 
                  onClick={openGuestWindow}
                >
                  <ExternalLink size={18} className="me-2" />
                  Open Seller Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetSellerAccess;